module.exports = __webpack_public_path__ + "img/section8-img.21546110.png";